module.exports = __webpack_public_path__ + "img/2.72f207b5.jpg";